import { baseApi as api } from "../baseApi";
export const addTagTypes = ["Authentication"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      logout: build.mutation<LogoutApiResponse, LogoutApiArg>({
        query: () => ({ url: `/api/v1/auth/logout`, method: "POST" }),
        invalidatesTags: ["Authentication"],
      }),
      logoutEverywhere: build.mutation<
        LogoutEverywhereApiResponse,
        LogoutEverywhereApiArg
      >({
        query: () => ({ url: `/api/v1/auth/logout-all`, method: "POST" }),
        invalidatesTags: ["Authentication"],
      }),
      requestOtp: build.mutation<RequestOtpApiResponse, RequestOtpApiArg>({
        query: (queryArg) => ({
          url: `/api/v1/auth/request-otp`,
          method: "POST",
          body: queryArg.requestOtpForm,
        }),
        invalidatesTags: ["Authentication"],
      }),
      verifyOtp: build.mutation<VerifyOtpApiResponse, VerifyOtpApiArg>({
        query: (queryArg) => ({
          url: `/api/v1/auth/verify-otp`,
          method: "POST",
          body: queryArg.verifyOtpForm,
        }),
        invalidatesTags: ["Authentication"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as authApi };
export type LogoutApiResponse = unknown;
export type LogoutApiArg = void;
export type LogoutEverywhereApiResponse = unknown;
export type LogoutEverywhereApiArg = void;
export type RequestOtpApiResponse = /** status 200 OK */ OtpChallengeData;
export type RequestOtpApiArg = {
  requestOtpForm: RequestOtpForm;
};
export type VerifyOtpApiResponse = /** status 200 OK */ SessionData;
export type VerifyOtpApiArg = {
  verifyOtpForm: VerifyOtpForm;
};
export type OtpChallengeData = {
  /** Seconds the code remains valid; drives the resend countdown */
  expiresInSeconds?: number;
  /** Resends left in the current window */
  resendsRemaining?: number;
};
export type RequestOtpForm = {
  /** Any common format; normalised to E.164 */
  phone?: string;
};
export type SessionData = {
  /** Bearer token for the Authorization header. Hold it in memory only, never in localStorage. */
  accessToken?: string;
  displayName?: string;
  /** Seconds until the access token expires */
  expiresInSeconds?: number;
  roles?: "VENDOR"[];
  userId?: number;
};
export type VerifyOtpForm = {
  /** CAPTCHA token from the sign-in widget (action: signup) */
  captchaToken?: string;
  code?: string;
  /** Display name; sets or updates the account's name when given */
  displayName?: string;
  phone?: string;
};
export const {
  useLogoutMutation,
  useLogoutEverywhereMutation,
  useRequestOtpMutation,
  useVerifyOtpMutation,
} = injectedRtkApi;
